<template>
  <a-locale-provider :locale="frFR">
    <div id="app" class="h-100" :class="{ 'dark-theme': darkTheme }">
      <template v-if="!ie && !edge">
        <SplashScreen :isLoading="isLoading" />
          <main class="h-100" v-if="!isLoading">
            <router-view/>
            <Footer/>
          </main>
      </template>
      <template v-else>
        <a-row type="flex" class="h-100 w-100" align="middle" justify="center">
          <a-col :span="24">
            <p class="text-center incompatibility-text no-margin">Cette application n'est pas compatible avec ce navigateur, veuillez utiliser un autre navigateur tel que Firefox ou Chrome.</p>
          </a-col>
        </a-row>
      </template>
    </div>
  </a-locale-provider>
</template>

<script>
import frFR from 'ant-design-vue/lib/locale-provider/fr_FR'
import moment from 'moment'
import 'moment/locale/fr'
import { mapState, mapActions } from 'vuex'
import Footer from './components/Footer'
import SplashScreen from './components/SplashScreen.vue'

moment.locale('fr')
export default {
  name: 'app',
  data () {
    return {
      ie: this.$browserDetect.isIE,
      edge: this.$browserDetect.isEdge,
      frFR,
      isLoading: true
    }
  },
  components: {
    Footer,
    SplashScreen
  },
  methods: {
    ...mapActions({
      'initialiseStore': 'initialiseStore'
    })
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme
    })
  },
  created () {
    this.initialiseStore()
  },
  mounted () {
    setTimeout(() => {
      this.isLoading = false
    }, 1500)
  }
}
</script>

<style scoped lang="scss">
.incompatibility-text {
  font-size: 35px;
}
</style>
